const type = 'SET_AGREEMENT_CONDITIONS';

const setAgreementConditions = (data) => ({
  data,
  type,
});

export { type };
export default setAgreementConditions;
